"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var bannerBorderInfo = exports.bannerBorderInfo = "1px solid $color-info-600";
var bannerBackgroundInfo = exports.bannerBackgroundInfo = "$color-info-50";
var bannerIconInfo = exports.bannerIconInfo = "$color-info-700";
var bannerBorderSuccess = exports.bannerBorderSuccess = "1px solid $color-success-600";
var bannerBackgroundSuccess = exports.bannerBackgroundSuccess = "$color-success-50";
var bannerIconSuccess = exports.bannerIconSuccess = "$color-success-700";
var bannerBorderError = exports.bannerBorderError = "1px solid $color-error-600";
var bannerBackgroundError = exports.bannerBackgroundError = "$color-error-50";
var bannerIconError = exports.bannerIconError = "$color-error-700";
var bannerBorderWarning = exports.bannerBorderWarning = "1px solid $color-warning-600";
var bannerBackgroundWarning = exports.bannerBackgroundWarning = "$color-warning-50";
var bannerIconWarning = exports.bannerIconWarning = "$color-warning-700";
var bannerBorderNeutral = exports.bannerBorderNeutral = "$border-gray-300";
var bannerBackgroundNeutral = exports.bannerBackgroundNeutral = "$color-white";
var bannerIconNeutral = exports.bannerIconNeutral = "$color-gray-1000";
var bannerBorderLight = exports.bannerBorderLight = "$border-gray-300";
var bannerBackgroundLight = exports.bannerBackgroundLight = "$color-gray-100";
var bannerIconLight = exports.bannerIconLight = "$color-gray-700";